export default function MapSection() {
  const cities = ['Hackensack','Paramus','Teaneck','Fort Lee','Englewood','Ridgewood','Tenafly','Fair Lawn','Bergenfield','Mahwah','Hoboken','Jersey City','New York City','Closter','Demarest','Emerson','Harrington Park','Haworth','Hillsdale','Montvale'];
  return (
    <section className="py-20 px-6 lg:px-12 bg-teal-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-teal-600 text-sm font-semibold tracking-widest uppercase mb-3">Serving Bergen County & Beyond</p>
          <h2 className="font-heading text-4xl font-bold text-teal-950 mb-4">Visit Our Hackensack, NJ Office</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">235 Prospect Avenue, Suite LB · Hackensack, NJ 07601 · Conveniently located in the heart of Bergen County</p>
        </div>
        <div className="rounded-lg overflow-hidden border border-teal-100 mb-10">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3017.8!2d-74.0431!3d40.8856!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2f4b5abc12345%3A0xabcdef1234567890!2s235%20Prospect%20Ave%2C%20Hackensack%2C%20NJ%2007601!5e0!3m2!1sen!2sus!4v1234567890" width="100%" height="420" style={{border:0}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="A Better Alternative Medical Center – Hackensack NJ"></iframe>
        </div>
        <div>
          <h3 className="font-heading text-xl font-semibold text-teal-900 mb-5 text-center">Patients Travel From Across the Tri-State Area</h3>
          <div className="flex flex-wrap gap-2 justify-center">
            {cities.map(city => (
              <span key={city} className="bg-white border border-teal-200 text-teal-800 text-sm px-4 py-1.5 rounded-full">{city}, NJ</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
